import styled from 'styled-components'
import '@ongov/ontario-design-system-design-tokens/dist/css/_variables.css'

export const DidYouMeanContainer = styled.p`
  margin-top: 2rem;

  .inline-dym {
    display: inline;
    margin-right: 3px;
    font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 20px;
    color: #cd0000;
  }

  .bolded-suggestion {
    font-weight: bold;
    font-size: 20px;
    font-family: 'Raleway Modified', 'Helvetica Neue', Helvetica, Arial,
      sans-serif;
  }
`

export default {DidYouMeanContainer}
